// src/api/productApi.js
import api from './index';



//获取邀请任务的信息

export const getCommissionInfo = (uid) => api.post('/testapi/payment/commission_controller/get_commission_info', uid);


export const getCommissionUser = (uid) => api.post('/testapi/payment/commission_controller/get_commission_all_user_test', uid);


// 获取产品数据（通用方法，已有）
export const getProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_for_zd_web', params);
};

// 获取镜像站展示产品（用于首页展示的精选镜像产品）
export const getMirrorDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/getMirrorDisplayProducts', params);
};

// 获取成品号展示产品（用于首页展示的精选成品号）
export const getFinishedDisplayProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_google_001', params);
};

// 获取所有镜像站产品（完整镜像产品列表）
export const getAllMirrorProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/getAllMirrorProducts', params);
};

// 获取所有成品号产品（完整成品号列表）
export const getAllFinishedProducts = (params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_list_google_001', params);
};

// 获取具体的产品详情（根据产品 ID）
export const getProductDetail = (productId, params = {}) => {
  return api.post('/testapi/payment/product_controller/get_product_detail', {
    productId,
    ...params,
  });
};

// 新增：提交订单
export const submitOrder = (orderData) => api.post('/testapi/payment/payment_ali_hk_controller/submit_order', orderData);

export const checkOrderStatus = (out_trade_no) => api.post('/testapi/payment/payment_controller/check_order', { out_trade_no });


